import { render, staticRenderFns } from "./scan-payment.vue?vue&type=template&id=37725d8c&"
import script from "./scan-payment.vue?vue&type=script&lang=js&"
export * from "./scan-payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports